// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-sec-6 .footer-title{
    font-size:40px;
    font-weight: 700;
    font-family: 'Poppins';
    line-height: 56px;
}

h1{
    font-size:44px;
    font-weight: 600;
    margin-bottom: 0;
    color: #fff;
}
h2{
    font-size:32px;
    font-weight: 400;
    margin-bottom: 1.022721rem ;
    color: #fff;
    line-height: 38px;
}
.common-section p{
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 1.33398rem;
}

.contact-img{
    position: relative;
    bottom: 3px;
}

@media (min-width:768px) and (max-width: 992px) {
    .common-section{
        padding: 0;
    }
}

@media (max-width: 992px) {
    /* .common-section{
        margin-bottom: 100px;
    } */
    h1{
        font-size: 40px;
        font-weight: 600;
        
    }
    .common-section p{
       margin-bottom: 0px;
        font-size: 16px !important;
        line-height: 26px !important;
        
    }
    button{
        font-size: 15px;
    }
}

@media (max-width: 768px) {
   .common-section{
    margin-bottom: 0px;
    
    }
    .gallery-sec-1{
        margin-right: 3rem;
    }
 
}
@media (max-width:576px){
    .common-section{
        margin-bottom: -2px;
    }
    .common-section p{
        margin-bottom: 0px;
         font-size: 15px !important;
         line-height: 24px !important;
         
     }
}
`, "",{"version":3,"sources":["webpack://./src/common-componets/CommonSection.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,2BAA2B;IAC3B,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;;OAEG;IACH;QACI,eAAe;QACf,gBAAgB;;IAEpB;IACA;OACG,kBAAkB;QACjB,0BAA0B;QAC1B,4BAA4B;;IAEhC;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;GACG;IACC,kBAAkB;;IAElB;IACA;QACI,kBAAkB;IACtB;;AAEJ;AACA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,kBAAkB;SACjB,0BAA0B;SAC1B,4BAA4B;;KAEhC;AACL","sourcesContent":[".home-sec-6 .footer-title{\r\n    font-size:40px;\r\n    font-weight: 700;\r\n    font-family: 'Poppins';\r\n    line-height: 56px;\r\n}\r\n\r\nh1{\r\n    font-size:44px;\r\n    font-weight: 600;\r\n    margin-bottom: 0;\r\n    color: #fff;\r\n}\r\nh2{\r\n    font-size:32px;\r\n    font-weight: 400;\r\n    margin-bottom: 1.022721rem ;\r\n    color: #fff;\r\n    line-height: 38px;\r\n}\r\n.common-section p{\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    margin-bottom: 1.33398rem;\r\n}\r\n\r\n.contact-img{\r\n    position: relative;\r\n    bottom: 3px;\r\n}\r\n\r\n@media (min-width:768px) and (max-width: 992px) {\r\n    .common-section{\r\n        padding: 0;\r\n    }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n    /* .common-section{\r\n        margin-bottom: 100px;\r\n    } */\r\n    h1{\r\n        font-size: 40px;\r\n        font-weight: 600;\r\n        \r\n    }\r\n    .common-section p{\r\n       margin-bottom: 0px;\r\n        font-size: 16px !important;\r\n        line-height: 26px !important;\r\n        \r\n    }\r\n    button{\r\n        font-size: 15px;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n   .common-section{\r\n    margin-bottom: 0px;\r\n    \r\n    }\r\n    .gallery-sec-1{\r\n        margin-right: 3rem;\r\n    }\r\n \r\n}\r\n@media (max-width:576px){\r\n    .common-section{\r\n        margin-bottom: -2px;\r\n    }\r\n    .common-section p{\r\n        margin-bottom: 0px;\r\n         font-size: 15px !important;\r\n         line-height: 24px !important;\r\n         \r\n     }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
